import { useTranslate } from '@common/hooks'
import type enTranslation from '@common/i18n/translations/en.json'
import Button from '@common/widgets/Button'
import cx from 'classnames'
import { useState } from 'react'

import classNames from './styles.module.scss'


interface IProps {
  onCancel: () => void
  handleAction: () => Promise<void>
  confirmationTitle: keyof typeof enTranslation
  confirmationDescription: keyof typeof enTranslation
  submitBtnText?: keyof typeof enTranslation
  cancelBtnText?: keyof typeof enTranslation
  confirmationError?: string | null
}

ConfirmationModal.defaultProps = {
  cancelBtnText: 'Cancel',
  submitBtnText: 'Remove review',
  confirmationError: null,
}

export default function ConfirmationModal({
  cancelBtnText,
  confirmationError,
  confirmationTitle,
  confirmationDescription,
  handleAction,
  onCancel,
  submitBtnText,
}: IProps): JSX.Element {
  const { translate } = useTranslate()
  const [isLoading, setIsLoading] = useState(false)

  const executeAction = () => {
    setIsLoading(true)
    handleAction()
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <section className={classNames.wrapper}>
      <h2 className={cx(classNames.title, classNames.remove)} data-test="modal-title">
        {translate(confirmationTitle)}
      </h2>
      <p className={cx(classNames.description, classNames.remove)} data-test="modal-description">
        {translate(confirmationDescription)}
      </p>
      <p className={classNames.error}>{confirmationError}</p>
      <footer className={classNames.footer}>
        <Button variant="secondary" className={classNames.cancelBtn} onClick={onCancel} data-test="cancel-btn">
          {cancelBtnText && translate(cancelBtnText)}
        </Button>
        <Button
          className={classNames.removeBtnConfirmation}
          data-test="action-btn"
          onClick={executeAction}
          width="lg"
          isLoading={isLoading}
        >
          {submitBtnText && translate(submitBtnText)}
        </Button>
      </footer>
    </section>
  )
}
